import React, { useEffect, useState } from 'react'
import { Buffer } from 'buffer'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MySpiner from '../../../../UI/spiner/MySpiner'
import MyButton from '../../../../UI/form/MyButton'
import { getSeriesQrCodeAPI } from '../../../../../api/pack/seriesAPI'

const SeriesQr = ({ seriesId, setOpen, type }) => {

    const [result, setResult] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        if (result) {
            getFile()
        }
    }, [result])

    const getQrs = () => {
        setError('')
        setLoading (true)
        getSeriesQrCodeAPI({ seriesId: seriesId, type }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

    const getFile = () => {
        const buffer = Buffer.from(result.file);
        const blob = new Blob([buffer]);

        // const name = type && type === 'barcode' ? "штрих-код на серію.png" : "qr-код на серію.png"
        const name = type && type === 'barcode' ? `штрих-код ${result.fileName}.png` : `qr-код ${result.fileName}.png`
                                   
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);

        setResult('')

        setOpen(false)
    }

  return (
    <div>
        <p className='packResultBlock__text'>Буде отриманий QR-код одного товару</p>

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            result ?
                getFile()
            : ''
        }
        {
            error ?
                <div className='error'>
                    { error }
                </div>
            : ''
        }

        <MyButton
            size='md'
            onClick={getQrs}
            disabled={loading ? true : false}
        >
            Отримати QR-код
        </MyButton>
    </div>
  )
}

export default SeriesQr